import JSConfetti from "js-confetti"

const jsConfetti = new JSConfetti()

export const addConfetti = () => {
  jsConfetti.addConfetti({
    confettiColors: ["#624BEC", "#FF6115", "#FFC038"],
  })
}
